import { render, staticRenderFns } from "./ConfigurarLanding.vue?vue&type=template&id=73dd1e46&"
import script from "./ConfigurarLanding.vue?vue&type=script&lang=ts&"
export * from "./ConfigurarLanding.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/runner/work/portal-track3/portal-track3/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!module.hot.data) {
      api.createRecord('73dd1e46', component.options)
    } else {
      api.reload('73dd1e46', component.options)
    }
    module.hot.accept("./ConfigurarLanding.vue?vue&type=template&id=73dd1e46&", function () {
      api.rerender('73dd1e46', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/plataforma/ConfigurarLanding.vue"
export default component.exports